
import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../Context/AuthContext.jsx";

const AwardRule = ({ activeTab }) => {
    const { token, user } = useAuth();
    const [selectedValue, setSelectedValue] = useState('flat_rate');
    const [points, setPoints] = useState('');
    const [description, setDescription] = useState('')
    const [descriptonsecond, setDescriptionSecond] = useState('')
    const [message, setMessage] = useState("");
    const [fields, setFields] = useState([{ lower_limit: '', upper_limit: '', points: '' }]);
    const [timeoutId, setTimeoutId] = useState(null);
    const [messageTwo, setMessageTwo] = useState("");
    const [runningAwards, setRunningAwards] = useState([])
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showConfigModal, setShowConfigModal] = useState(false);

    const validateSlabFields = () => {
        return fields.every(field => {
            const lower = field.lower_limit !== '' ? parseFloat(field.lower_limit) : NaN;
            const upper = field.upper_limit !== '' ? parseFloat(field.upper_limit) : NaN;
            const pts = field.points !== '' ? parseFloat(field.points) : NaN;
            return !isNaN(lower) && !isNaN(upper) && !isNaN(pts) && upper > lower;
        });
    };

    const addFields = () => {
        const newFields = [...fields, { lower_limit: '', upper_limit: '', points: '' }];
        const lastUpperLimit = fields[fields.length - 1].upper_limit;

        if (lastUpperLimit) {
            newFields[newFields.length - 1].lower_limit = parseFloat(lastUpperLimit) + 1;
        }

        setFields(newFields);
    };

    const removeLastField = () => {
        if (fields.length > 1) {
            const newFields = fields.slice(0, -1);
            setFields(newFields);
        }
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;
        const newFields = [...fields];
        newFields[index][name] = value;

        if (timeoutId) clearTimeout(timeoutId);

        const id = setTimeout(() => {
            validateFields(newFields, index, name, value);
            setIsSubmitDisabled(!validateSlabFields());
        }, 1000);

        setTimeoutId(id);
        setFields(newFields);
    };

    const validateFields = (newFields, index, name, value) => {
        if (name === 'upper_limit') {
            const lowerLimitValue = parseFloat(newFields[index].lower_limit);
            if (value && parseFloat(value) <= lowerLimitValue) {
                // Silent validation or handle via UI state
            }
        }

        if (name === 'lower_limit' && index > 0) {
            const previousUpperLimit = parseFloat(newFields[index - 1].upper_limit);
            if (value && parseFloat(value) <= previousUpperLimit) {
                // Silent validation
            }
        }
    };

    const handleSelectChange = (event) => {
        setSelectedValue(event.target.value);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/awards/update-award`,
                {
                    "rule_type": "flat_rate",
                    "points": points,
                    "description": description,
                    "slab_details": []
                },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            if (response.status === 200) {
                setMessage(response.data.message)
                currentRules()
                setTimeout(() => {
                    setMessage("");
                    setDescription("")
                    setPoints("")
                    setShowConfigModal(false);
                }, 2000)
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleSubmitSlab = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/awards/update-award`,
                {
                    "rule_type": "slab_wise",
                    "points": 0,
                    "description": descriptonsecond,
                    "slab_details": fields
                },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            if (response.status === 200) {
                setMessageTwo(response.data.message)
                currentRules()
                setTimeout(() => {
                    setMessageTwo("");
                    setDescriptionSecond("")
                    setFields([{ lower_limit: '', upper_limit: '', points: '' }]);
                    setShowConfigModal(false);
                }, 2000)
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const currentRules = useCallback(async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/awards/current-rule`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.status === 200) {
                setRunningAwards(response.data.awardRule);
            }
        } catch (error) {
            console.error(error);
        }
    }, [token]);

    useEffect(() => {
        if (activeTab === 11) currentRules();
    }, [currentRules, activeTab]);

    const formatDate = (timestamp) => {
        if (!timestamp) return "N/A";
        return new Date(timestamp).toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    useEffect(() => {
        setIsSubmitDisabled(!validateSlabFields());
    }, [fields]);

    if (activeTab !== 11) return null;

    const history = runningAwards?.last_updated_by || [];
    const latest = history[history.length - 1];
    const previous = history.slice(0, -1).reverse();
    const displayHistory = isExpanded ? [latest, ...previous].filter(Boolean) : (latest ? [latest] : []);

    return (
        <div className="animate-fadeIn pb-12 space-y-10">

            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start gap-4">
                <div className="flex flex-col items-start">
                    <h2 className="text-2xl font-bold text-gray-900 tracking-tight">Award Management</h2>
                    <p className="text-sm text-gray-500 font-medium">Configure point systems and incentive structures.</p>
                </div>
                <button
                    onClick={() => setShowConfigModal(true)}
                    className="px-6 py-3 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-bold text-sm transition-all flex items-center gap-2"
                >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    Update Award Rules
                </button>
            </div>

            {/* Current Active Rule Card */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-8 py-6 border-b border-gray-100 bg-gray-50/50 flex justify-between items-center">
                    <h3 className="text-base font-semibold text-gray-800">Current Active Configuration</h3>
                    {previous.length > 0 && (
                        <button
                            onClick={() => setIsExpanded(!isExpanded)}
                            className="text-xs font-medium text-[#004f6b] hover:underline px-4"
                        >
                            {isExpanded ? 'Collapse' : `View Change History (${previous.length})`}
                        </button>
                    )}
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-left min-w-[900px]">
                        <thead>
                            <tr className="bg-gray-50 border-b border-gray-100">
                                <th className="px-8 py-4 text-xs font-semibold text-gray-600 text-center whitespace-nowrap">Sr. No</th>
                                <th className="px-8 py-4 text-xs font-semibold text-gray-600 whitespace-nowrap">Administrator</th>
                                <th className="px-8 py-4 text-xs font-semibold text-gray-600 whitespace-nowrap">Rule Type</th>
                                <th className="px-8 py-4 text-xs font-semibold text-gray-600 whitespace-nowrap">Base Points</th>
                                <th className="px-8 py-4 text-xs font-semibold text-gray-600 whitespace-nowrap">Slab Metrics</th>
                                <th className="px-8 py-4 text-xs font-semibold text-gray-600 whitespace-nowrap">Context</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50">
                            {displayHistory.length > 0 ? (
                                displayHistory.map((entry, index) => (
                                    <tr key={index} className="group hover:bg-gray-50/50 transition-colors">
                                        <td className="px-8 py-6 text-sm text-gray-400 font-mono text-center">{index === 0 ? 'Active' : `#${displayHistory.length - index}`}</td>
                                        <td className="px-8 py-6">
                                            <div className="flex flex-col">
                                                <span className="text-sm font-semibold text-gray-900">{entry.email}</span>
                                                <span className="text-xs text-gray-400 mt-0.5">{formatDate(entry.timestamp)}</span>
                                            </div>
                                        </td>
                                        <td className="px-8 py-6">
                                            <span className={`inline-flex px-3 py-1 rounded-lg text-xs font-medium border ${entry.pointRule === 'flat_rate' ? 'bg-blue-50 text-blue-700 border-blue-100' : 'bg-purple-50 text-purple-700 border-purple-100'}`}>
                                                {entry.pointRule === 'flat_rate' ? "Flat Rate" : "Slab Wise"}
                                            </span>
                                        </td>
                                        <td className="px-8 py-6">
                                            <span className="text-sm font-semibold text-gray-800">{entry.pointsflat || '—'}</span>
                                        </td>
                                        <td className="px-8 py-6">
                                            {entry?.pointSlab?.length > 0 ? (
                                                <div className="flex flex-wrap gap-2">
                                                    {entry.pointSlab.map((slab, i) => (
                                                        <span key={i} className="px-2 py-1 bg-gray-100 text-gray-600 rounded text-xs font-normal border border-gray-200">
                                                            {slab.lower_limit}-{slab.upper_limit}: {slab.points}pts
                                                        </span>
                                                    ))}
                                                </div>
                                            ) : (
                                                <span className="text-xs text-gray-400 font-medium">No Slabs Configured</span>
                                            )}
                                        </td>
                                        <td className="px-8 py-6 text-sm text-gray-600 italic">
                                            "{entry?.description || 'No description provided'}"
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" className="px-8 py-20 text-center text-gray-400 font-medium italic">Initializing system award rules...</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Configurator Modal */}
            {showConfigModal && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                    {/* Backdrop */}
                    <div
                        className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm animate-fadeIn"
                        onClick={() => !isSubmitting && setShowConfigModal(false)}
                    ></div>

                    {/* Modal Content */}
                    <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto animate-zoomIn border border-gray-100">
                        <div className="sticky top-0 z-10 p-6 border-b border-gray-100 bg-white/80 backdrop-blur-md flex flex-col md:flex-row justify-between items-center gap-6">
                            <div className="space-y-1">
                                <h3 className="text-xl font-bold text-start text-gray-900">Award Rule Configurator</h3>
                                <p className="text-sm text-gray-500 text-start font-medium">Select a methodology to update current incentives.</p>
                            </div>
                            <div className="flex items-center gap-4 w-full md:w-auto">
                                <div className="relative flex-1 md:w-64 group">
                                    <select
                                        value={selectedValue}
                                        onChange={handleSelectChange}
                                        className="w-full pl-5 pr-10 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium text-[#004f6b] outline-none appearance-none focus:ring-4 focus:ring-[#004f6b]/10 focus:border-[#004f6b] transition-all cursor-pointer shadow-sm group-hover:border-gray-300"
                                    >
                                        <option value="none" disabled>Select Methodology</option>
                                        <option value="flat_rate">Flat Rate System</option>
                                        <option value="slab_wise">Slab-Wise Tiering</option>
                                    </select>
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none text-gray-400 group-hover:text-[#004f6b] transition-colors">
                                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" /></svg>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setShowConfigModal(false)}
                                    className="p-3 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-xl transition-all"
                                >
                                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <div className="p-10">
                            {selectedValue === 'none' && (
                                <div className="py-20 text-center space-y-4">
                                    <div className="h-20 w-20 bg-gray-50 rounded-full flex items-center justify-center mx-auto border border-dashed border-gray-200">
                                        <svg className="w-10 h-10 text-gray-200" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" /></svg>
                                    </div>
                                    <p className="text-sm font-medium text-gray-400">Awaiting strategy selection</p>
                                </div>
                            )}

                            {selectedValue === 'flat_rate' && (
                                <form onSubmit={handleSubmit} className="max-w-4xl mx-auto space-y-8 animate-fadeIn">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                        <div className="space-y-2">
                                            <label className="text-xs font-medium text-gray-500 pl-1">Incentive Points</label>
                                            <div className="relative group">
                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    placeholder="Ex: 500"
                                                    required
                                                    className="w-full pl-5 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/10 focus:border-[#004f6b] outline-none transition-all font-bold text-lg text-gray-800"
                                                    value={points}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === "" || (/^\d+$/.test(value) && parseInt(value, 10) > 0)) {
                                                            setPoints(value);
                                                        }
                                                    }}
                                                />
                                                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-xs font-medium text-gray-300">Per Referral</div>
                                            </div>
                                        </div>
                                        <div className="space-y-2">
                                            <label className="text-xs font-medium text-gray-500 pl-1">Configuration Context</label>
                                            <input
                                                type="text"
                                                placeholder="Reason for change (e.g. Summer Promo)"
                                                className="w-full px-5 py-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-4 focus:ring-blue-500/10 focus:border-[#004f6b] outline-none transition-all text-sm font-medium"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {message && <div className="bg-green-50 text-green-700 px-5 py-3 rounded-xl border border-green-100 text-xs font-medium flex items-center gap-3 animate-bounce">✓ {message}</div>}

                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`w-full py-4 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all flex items-center justify-center gap-3 active:scale-95 ${isSubmitting ? 'opacity-70' : ''}`}
                                    >
                                        Deploy Flat Strategy
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                                    </button>
                                </form>
                            )}

                            {selectedValue === 'slab_wise' && (
                                <form onSubmit={handleSubmitSlab} className="max-w-6xl mx-auto space-y-10 animate-fadeIn">
                                    <div className="space-y-2">
                                        <label className="text-xs font-medium text-gray-500 pl-1">Campaign Description</label>
                                        <input
                                            type="text"
                                            placeholder="Enter detailed description for this slab structure..."
                                            required
                                            className="w-full px-6 py-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-4 focus:ring-purple-500/10 focus:border-[#004f6b] outline-none transition-all text-sm font-medium"
                                            value={descriptonsecond}
                                            onChange={(e) => setDescriptionSecond(e.target.value)}
                                        />
                                    </div>

                                    <div className="space-y-4">
                                        <div className="flex justify-between items-center px-2">
                                            <h4 className="text-xs font-medium text-gray-400">Tiered Milestone Configuration</h4>
                                            <div className="flex gap-4">
                                                <button type="button" onClick={addFields} className="px-4 py-2 bg-gray-50 text-gray-600 rounded-lg border border-gray-200 text-xs font-medium hover:bg-gray-100 transition-all flex items-center gap-2">
                                                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" /></svg>
                                                    Add Tier
                                                </button>
                                                {fields.length > 1 && (
                                                    <button type="button" onClick={removeLastField} className="px-4 py-2 bg-red-50 text-red-600 rounded-lg border border-red-100 text-xs font-medium hover:bg-red-100 transition-all">
                                                        Remove Last
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 gap-3">
                                            {fields.map((field, index) => (
                                                <div key={index} className="flex flex-col md:flex-row gap-3 p-4 bg-gray-50/50 rounded-2xl border border-gray-100 items-end">
                                                    <div className="flex-1 space-y-1.5">
                                                        <label className="text-xs font-medium text-gray-400 pl-1">Min Referrals</label>
                                                        <input
                                                            type="text"
                                                            name="lower_limit"
                                                            placeholder="0"
                                                            value={field.lower_limit}
                                                            onChange={(e) => /^\d*$/.test(e.target.value) && handleChange(index, e)}
                                                            className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:border-[#004f6b] outline-none text-sm font-medium"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="flex-1 space-y-1.5">
                                                        <label className="text-xs font-medium text-gray-400 pl-1">Max Referrals</label>
                                                        <input
                                                            type="text"
                                                            name="upper_limit"
                                                            placeholder="10"
                                                            value={field.upper_limit}
                                                            onChange={(e) => /^\d*$/.test(e.target.value) && handleChange(index, e)}
                                                            className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:border-[#004f6b] outline-none text-sm font-medium"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="flex-1 space-y-1.5">
                                                        <label className="text-xs font-medium text-gray-400 pl-1">Award Points</label>
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            name="points"
                                                            placeholder="Base Pts"
                                                            value={field.points}
                                                            onChange={(e) => (/^[1-9]\d*$/.test(e.target.value) || e.target.value === "") && handleChange(index, e)}
                                                            className="w-full px-4 py-3 bg-blue-50 border border-blue-100 rounded-xl focus:border-[#004f6b] outline-none text-sm font-bold text-blue-700"
                                                            required
                                                        />
                                                    </div>
                                                    <div className="pb-3 px-2 hidden md:block">
                                                        <div className="h-6 w-6 rounded-full bg-white border border-gray-100 flex items-center justify-center text-xs font-medium text-gray-300">#{index + 1}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {messageTwo && <div className="bg-green-50 text-green-700 px-5 py-3 rounded-xl border border-green-100 text-xs font-medium flex items-center gap-3 animate-bounce">✓ {messageTwo}</div>}

                                    <div className="pt-4">
                                        <button
                                            type="submit"
                                            disabled={isSubmitDisabled || isSubmitting}
                                            className={`w-full py-5 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all  flex items-center justify-center gap-3 ${isSubmitDisabled || isSubmitting ? 'opacity-40 cursor-not-allowed grayscale' : 'active:scale-95'}`}
                                        >
                                            {isSubmitting ? 'Processing Audit Log...' : 'Deploy Slab Configuration'}
                                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                                        </button>
                                        {isSubmitDisabled && !isSubmitting && (
                                            <p className="text-center text-xs font-medium text-red-500 mt-4">⚠️ Upper limits must be strictly greater than lower limits in all tiers</p>
                                        )}
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                @keyframes zoomIn {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
                .animate-zoomIn {
                    animation: zoomIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }
            `}</style>
        </div>
    )
}

export default AwardRule;